import { Component } from '@angular/core';
import { ButtonComponent } from 'component-library';
import { AuthService } from 'shared';

@Component({
  selector: 'tngh-permission-denied',
  templateUrl: './permission-denied.component.html',
  styleUrls: ['./permission-denied.component.scss'],
  imports: [ButtonComponent]
})
export class PermissionDeniedComponent {
  constructor(private authService: AuthService) {}

  logout() {
    this.authService.logout();
  }
}
